import { forwardRef, InputHTMLAttributes } from 'react';
import { useField } from 'formik';
import cx from 'classnames';

interface TypedConfirmationInputProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}

interface FormikTypedConfirmationInputProps
  extends Omit<TypedConfirmationInputProps, 'name' | 'onBlur' | 'onChange' | 'value'> {
  name: string;
  validate?: (value: string) => string | undefined | Promise<string | undefined>;
}

const typedConfirmationInputClassName =
  "h-[55px] w-full rounded-[5px] border border-[#86939E] bg-white px-[2.3rem] font-['GT-Walsheim-Pro-Regular'] text-[2.2rem] text-[#86939E] outline-none placeholder:text-[#b0b8bf] placeholder:opacity-100";

const errorClassName = "mt-[0.4rem] min-h-[2rem] font-['GT-Walsheim-Pro-Regular'] text-[1.4rem] text-[#D30101]";

const TypedConfirmationInput = forwardRef<HTMLInputElement, TypedConfirmationInputProps>(
  ({ className, ...props }, ref): JSX.Element => {
    return <input {...props} ref={ref} className={cx(typedConfirmationInputClassName, className)} />;
  },
);

TypedConfirmationInput.displayName = 'TypedConfirmationInput';

export const FormikTypedConfirmationInput = ({
  className,
  ...props
}: FormikTypedConfirmationInputProps): JSX.Element => {
  const { name, validate, ...inputProps } = props;
  const [field, meta] = useField<string>({ name, validate });
  const hasError = meta.touched && meta.error;

  return (
    <div>
      <TypedConfirmationInput
        {...field}
        {...inputProps}
        className={className}
        aria-invalid={hasError ? true : undefined}
      />
      <div className={errorClassName}>{hasError ? meta.error : null}</div>
    </div>
  );
};

export default TypedConfirmationInput;
